import { render, staticRenderFns } from "./taskIndex.vue?vue&type=template&id=2a1546a0"
import script from "./taskIndex.vue?vue&type=script&lang=js"
export * from "./taskIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports